import React from 'react';

const UIicon = () => {
  return (
    <svg width="15" height="11" viewBox="0 0 15 11" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.33301 10.9998H9.49967V5.99984H5.33301V10.9998ZM0.333008 10.9998H4.49967V0.166504H0.333008V10.9998ZM10.333 10.9998H14.4997V5.99984H10.333V10.9998ZM5.33301 0.166504V5.1665H14.4997V0.166504H5.33301Z" fill="currentColor"/>
    </svg>
  )
}

export default UIicon;